module.exports = __webpack_public_path__ + "static/media/3 12 Tulleord Knain er feil-norming.98d5952b.mp3";